import React from "react";
import { withTranslation, TFunction } from "react-i18next";
import BgVideo from "../BgVideo";

const Footer = ({ t }: { t: TFunction }) => {
  return (
    <>
      {/* Final CTA section */}
      <section className="py-20 md:py-28 bg-teal overflow-hidden relative">
        <BgVideo
          src="https://video.gumlet.io/6acdfbdccebd948cdd3551e1/6ace04fbcebd948cdd3590d8/main.mp4"
          poster="/video/hero-rally-poster.jpeg"
          label="Tennis serve in motion"
          width={1920}
          height={1080}
          className="absolute inset-0"
          videoClassName="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-teal/60 pointer-events-none" aria-hidden="true" />
        <div className="max-w-4xl mx-auto px-6 md:px-8 text-center relative z-10">
          <p className="text-xs font-black tracking-[0.2em] uppercase text-paper/60 mb-4 m-0">First game is on us. All of them are free, actually.</p>
          <h2 className="font-headline font-black text-paper tracking-tight mb-4 m-0 text-5xl md:text-6xl leading-[1.02]">
            See you<br />on court.
          </h2>
          <p className="text-paper/70 text-lg mb-10 m-0">Two minutes to set up. Years of Saturday mornings.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://apps.apple.com/app/apple-store/id6683305729"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-solid bg-transparent text-white border border-white/50 px-10 py-5 rounded-xl text-lg font-bold no-underline inline-block"
            >
              App Store
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.rgs.ready2play"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-solid bg-accent-coral text-white px-10 py-5 rounded-xl text-lg font-bold no-underline inline-block"
            >
              Google Play
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white w-full py-12 px-6 md:px-8 border-t-2 border-ink">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="font-headline text-xl font-black text-ink">Ready2Play</div>
          <div className="flex gap-8 flex-wrap justify-center">
            {[
              { label: "Privacy", href: "/privacy-policy.html" },
              { label: "Terms", href: "/terms-and-conditions.html" },
              { label: "Support", href: "/support" },
              { label: "Contact", href: "/contact" },
            ].map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-sm tracking-wide uppercase font-semibold text-ink-soft hover:text-teal transition-colors no-underline"
              >
                {link.label}
              </a>
            ))}
          </div>
          <p className="text-sm font-semibold text-ink-soft m-0">
            &copy; {new Date().getFullYear()} Ready2Play. All rights reserved.
          </p>
        </div>
        <div className="max-w-7xl mx-auto flex justify-center mt-6">
          <p className="text-xs text-ink-soft/70 m-0">
            Photography: Macourt Media, RDNE Stock project, Mason Tuttle, Zetong Li, Patrick Case via Pexels. Motion: cottonbro studio, RDNE Stock project, Antoni Shkraba via Pexels video. <a href="/img/photo/CREDITS.md" className="underline hover:text-teal transition-colors">Full credits</a>.
          </p>
        </div>
      </footer>
    </>
  );
};

export default withTranslation()(Footer);
